import { Box, withStyles } from '@material-ui/core';
import FsCaption from 'ui-elements/typography/FsCaption';
import FsSubtitle from 'ui-elements/typography/FsSubtitle';
import FsHeaderLarge from 'ui-elements/typography/FsHeaderLarge';

export const WrapperBox = withStyles(() => ({
  root: {},
}))(Box);

export const Caption = withStyles(({ palette }) => ({
  root: {
    color: palette.grey[300],
  },
}))(FsCaption);

export const Header = withStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(2),
    fontWeight: 700,
  },
}))(FsHeaderLarge);

export const SubHeader = withStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(2),
    fontWeight: 400,
  },
}))(FsSubtitle);
